(function(){
    'use strict';

    angular.module('elogbooks.admin.document-types-management', []);
})();